import { Container, Title } from '@styles/global.styled'
import WagtailBlocksSection from '../components/global/Blocks/WagtailBlocksSection'

const IframePage = ({ pageData }) => {
  const { heading, heading_align, iframe_code } = pageData

  return (
    <>
      {heading && (
        <Container
          style={{
            marginBottom: '20px',
            marginTop: '60px',
          }}
        >
          <Title
            style={{
              marginBottom: '0',
              textAlign: heading_align
                ? heading_align === 'centre'
                  ? 'center'
                  : 'left'
                : '',
            }}
          >
            {heading}
          </Title>
        </Container>
      )}
      <WagtailBlocksSection blocks={pageData.content_blocks} />

      {iframe_code && (
        <Container>
          <div dangerouslySetInnerHTML={{ __html: iframe_code }} />
        </Container>
      )}
    </>
  )
}

export default IframePage
